/** First letter upper, rest lower — per word. */
export function capitalizeNamePart(value) {
  const v = String(value || '').trim();
  if (!v) return '';
  return v
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
}
